import { render, staticRenderFns } from "./AddOtherIncome.vue?vue&type=template&id=ce2c523c"
import script from "./AddOtherIncome.vue?vue&type=script&lang=js"
export * from "./AddOtherIncome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports